import React from 'react';

const SPFooter = () => {
    return (
        <div>
            <footer className="bg-fusion-blue text-fusion-white">
                <div className="mx-auto grid max-w-7xl gap-10 px-6 py-12 text-sm md:grid-cols-3 lg:px-10">
                    <div className="space-y-3">
                        <h3 className="text-lg font-bold uppercase tracking-wide text-fusion-white mb-3">Reach Us</h3>
                        <div className="mt-2 space-y-1">
                          <a href="mailto:fusiontechfzco@gmail.com" className="block text-fusion-white/90 transition hover:text-white pt-5">
                              Email: info@fusiontechuae.com
                          </a>
                          <a href="tel:+971522340058" className="block text-fusion-white/90 transition hover:text-white">
                              Mobile/WhatsApp: +971 52 234 0058
                          </a>
                        </div>
                    </div>

                    <div className="space-y-3">
                        <h3 className="text-lg font-bold uppercase tracking-wide text-fusion-white">ADDRESS</h3>
                        <p className="leading-7 text-fusion-white/90">
                            Fusion Tech General Trading FZCO
                            <br />
                            IFZA Business Park Building A1
                            <br />
                            Dubai Silicon Oasis, Dubai, U.A.E.
                        </p>
                    </div>

                    <div className="space-y-3">
                        <h3 className="text-lg font-bold uppercase tracking-wide text-fusion-white">Legal</h3>
                        <div className="mt-2 space-y-1 pt-5">
                          <a href="/terms" className="block text-fusion-white/90 transition hover:text-white">
                              Terms of Use
                          </a>
                          <a href="/privacy" className="block text-fusion-white/90 transition hover:text-white">
                              Privacy Policy
                          </a>
                          <a href="/cookies" className="block text-fusion-white/90 transition hover:text-white">
                              Cookie Policy
                          </a>
                        </div>
                    </div>
                </div>
                <div className="mx-auto max-w-7xl px-6 pb-6 lg:px-10 text-sm text-fusion-white/80">
                    {/* Ethiopian secondary office removed per request */}
                </div>
            </footer>

            {/* <footer className="border-t border-white/20 bg-fusion-orange text-fusion-white">
                <div className="mx-auto flex max-w-7xl flex-col gap-4 px-6 py-4 text-sm font-semibold md:flex-row md:items-center md:justify-between lg:px-10">
                    <p>BUILT BY DANIEL TIBEBU / +251910710569</p>
                    <div className="flex items-center gap-4 text-fusion-white/90">
                        <span className="h-2 w-2 rounded-full bg-white" />
                        <span>Fusion Tech General Trading FZCO</span>
                    </div>
                </div>
            </footer> */}
        </div>
    );
};

export default SPFooter;